import { useCallback, useState } from "react";
import useRefCache from "./useRefCache";
/**
 * This hooks provides an easy way to toggle a boolean flag for React
 * components.  The main use case for this will be toggling the visibility of
 * something. All the provided actions are guaranteed to never change.
 *
 * @param defaultToggled Boolean if the visibility should be enabled first
 * render.
 * @return an array containing the toggled state, an enable function, a disable
 * function, a toggle function, and then a manual set toggle function.
 */
export default function useToggle(defaultToggled) {
    var _a = useState(defaultToggled), toggled = _a[0], setToggled = _a[1];
    var previous = useRefCache(toggled);
    var enable = useCallback(function () {
        if (!previous.current) {
            setToggled(true);
        }
        // disabled since useRefCache
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var disable = useCallback(function () {
        if (previous.current) {
            setToggled(false);
        }
        // disabled since useRefCache
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var toggle = useCallback(function () {
        setToggled(function (prevVisible) { return !prevVisible; });
    }, []);
    return [toggled, enable, disable, toggle, setToggled];
}
//# sourceMappingURL=useToggle.js.map